// import Progress from 'antd/es/progress';
import './index.css'
import { ClipboardList, Eye, Clock, Target, BookOpen, X, CheckCircle, XCircle, RefreshCw } from 'lucide-react';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { Image, Modal } from '@components/shares';
import { Event } from 'react-big-calendar';
// import moment from 'moment';
import { useStudentDashboard } from '@hooks/useStudentDashboard';
import teacher from "@assets/images/teacher.svg";
import dayjs from 'dayjs';
import { useStudentPractice } from '@hooks/useStudentPractice';
import { useCommon } from '@hooks/useCommon';
import { useAuth } from '@hooks/useAuth';
import { history } from '@utils/BrowserHistory';
import { Table, Tag, Spin, Button } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import Select from 'antd/es/select';
import { useLocation } from 'react-router-dom';
import { useAdminReporting } from '@hooks/useAdminReporting';
import PracticeAttemptDetail from '@features/admin/reporting/reportPractice/PracticeAttemptDetail';

type Props = {}

interface MyEvent extends Event {
    id: number;
}

interface SubModuleReport {
    submodule_child_name: string;
    submodule_child_id: number;
    total_question: number;
    pass_question: number;
    sub_activity_status: number;
    highest_score: number;
    lowest_score: number;
    total_times: number;
    start_time: string;
}

interface PracticeResult {
    stt: number;
    sub_module_name: string;
    times: number;
    question_count: number;
    question_success: number;
}

interface ProcessedSkillData {
    skillName: string;
    practiceCount: number;
    totalQuestions: number;
    passedQuestions: number;
    sub_activity_status: number;
    lastTimesScore: number;
    highestScore: number;
    lowestScore: number;
    total_times: number;
    latest_times: string;
    submodule_id?: number;
}

interface SuggestedPractice {
    class_id: number;
    submodule_id: number;
    submodule_name: string;
    total_question: number;
    pass_question: number;
    child_lv1: {
        child_id: number;
        child_name: string;
    }[];
}

interface AttemptDetail {
    id: number;
    student_id: number;
    student_name: string;
    submodule_id: number;
    submodule_name: string;
    pass_questions: number;
    total_questions: number;
    created_date: string;
    updated_date: string;
    number_active: number;
    attempt_number: number;
    score_ratio: number;
    passed: boolean;
    start_time: string;
    end_time: string;
    duration_minutes: number;
    score: string;
}

interface FilterProps {
    filterData: {
        id?: number;
        class_id?: number;
        class_name?: string;
        name?: string;
        status?: number;
        start_date?: string;
        end_date?: string;
    };
    setFilterDataAction: (data: any) => void;
    studentClassModuleList: any[];
    useModuleFilter?: boolean;
    useTimeFilter?: boolean;
}

const encouragementMessages = [
    "Học, học nữa, học mãi! 🎉",
    "Hãy tiếp tục phát huy khả năng của bạn! 💪",
    "Bạn có tiềm năng rất lớn! Hãy cố gắng hơn nữa! ⭐",
    "Mỗi ngày học tập là một bước tiến mới! 🌱",
    "Cố lên, bạn sẽ làm được! 🚀",
    "Học tập chăm chỉ sẽ mang lại thành công! 🏆"
];

const getEncouragementMessage = () => {
    const idx = Math.floor(Math.random() * encouragementMessages.length);
    return encouragementMessages[idx];
};

const formatLatestTimes = (dateString: string) => {
    if (!dateString) return '';
    const date = dayjs(dateString);
    return date.format('DD/MM/YY HH:mm:ss');
};

const ReportChart: React.FC<FilterProps> = ({
    filterData,
    setFilterDataAction,
    studentClassModuleList,
}) => {
    const { userDetail } = useCommon();
    const { auth } = useAuth();
    const [skillsData, setSkillsData] = useState<ProcessedSkillData[]>([]);
    const [encouragementMessage, setEncouragementMessage] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [filteredRecommendedPractices, setFilteredRecommendedPractices] = useState<any[]>([]);
    const { fetchReportStudentPracticeActivityAction, practiceDashboardData, loading } = useStudentDashboard();
    const {
        fetchSubModuleTreeAction,
        subModuleTree,
        loading: loadingPractice,
        practiceEnrollSingleItemAction,
        resetPracticeEnrollDataAction,
        setCurrentModulePracticeAction
    } = useStudentPractice()
    const { studentReportingDetail, fetchStudentReportingDetailAction } = useAdminReporting();

    // State cho viewdetail modal
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedSkill, setSelectedSkill] = useState<ProcessedSkillData | null>(null);
    const [attemptDetails, setAttemptDetails] = useState<AttemptDetail[]>([]);
    const [selectedAttempt, setSelectedAttempt] = useState<AttemptDetail | null>(null);
    const [detailLoading, setDetailLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);

    const moduleOptions = studentClassModuleList.map((module: any) => ({
        label: module.name,
        value: module.id
    }));

    // Handle change module
    const handleChangeModule = (value: number) => {
        const selectedModule = studentClassModuleList.find((m: any) => m.id === value);
        setFilterDataAction({
            ...filterData,
            id: value,
            name: selectedModule?.name,
            class_id: selectedModule?.class_id,
            class_name: selectedModule?.class_name
        });
    };
    const [clickEvent, setClickEvent] = useState(null);
    const [isOpenEventModal, setIsOpenEventModal] = useState(false)
    const [recommendedPractices, setRecommendedPractices] = useState<{
        submodule_name: string;
        practice_name: string;
        submodule_id: number;
        child_id: number;
        class_id: number;
    }[]>([]);

    //hidden skills that have no practice count or latest times !!!
    const practicedSkills = skillsData.filter(skill =>
        skill.practiceCount > 0 && skill.latest_times !== 'Không có dữ liệu'
    );

    // Add ref for skills table container
    const skillsTableRef = useRef<HTMLDivElement>(null);
    const [tableHeight, setTableHeight] = useState<number>(400);

    const handleEventClick = (event: any, e: any) => {
        setClickEvent(event)
        setIsOpenEventModal(true)
    };

    useEffect(() => {
        if (filterData?.id) {
            fetchReportStudentPracticeActivityAction({ module_id: filterData?.id, start_date: '01/01/1966', end_date: '01/01/2100', status: 2 });
        }
    }, [filterData]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const moduleParam = params.get('module');
        const classParam = params.get('class');

        if (moduleParam && classParam) {
            const selectedModule = studentClassModuleList.find((m: { id: number; }) =>
                m.id === parseInt(moduleParam)
            );
            if (selectedModule) {
                setFilterDataAction({
                    ...filterData,
                    id: selectedModule.id,
                    name: selectedModule.name,
                    class_id: selectedModule.class_id,
                    class_name: selectedModule.class_name
                });
            }
        }
    }, [location.search, studentClassModuleList]);

    useEffect(() => {
        if (subModuleTree && recommendedPractices) {
            const filteredModule = recommendedPractices.filter(practice =>
                subModuleTree.some((module: { id: number; }) => module.id === practice.submodule_id)
            );
            setFilteredRecommendedPractices(filteredModule);
        }
    }, [subModuleTree, recommendedPractices]);

    useEffect(() => {
        if (practiceDashboardData?.sub_module_child_report && practiceDashboardData?.results) {
            // Step 1: Process sub_module_child_report to get skills
            const subModules = practiceDashboardData?.sub_module_child_report.map((module: SubModuleReport) => ({
                skillName: module.submodule_child_name,
                totalQuestions: module.total_question,
                passedQuestions: module.pass_question,
                sub_activity_status: module.sub_activity_status,
                highestScore: module.highest_score, // Số câu đúng cao nhất
                total_times: module.total_times,
                latest_times: module.start_time,
                lowestScore: module.lowest_score // Số câu đúng thấp nhất
            }));

            // Step 2: Group results by sub_module_name
            const resultGroups = practiceDashboardData.results.reduce((acc: { [x: string]: any[]; }, result: PracticeResult) => {
                if (!acc[result.sub_module_name]) {
                    acc[result.sub_module_name] = [];
                }
                acc[result.sub_module_name].push(result);
                return acc;
            }, {} as Record<string, PracticeResult[]>);

            // Step 3: Process final data
            const processedData = subModules.map((module: ProcessedSkillData) => {
                const results = resultGroups[module.skillName] || [];

                // Lấy điểm lần gần nhất (lastTimesScore)
                const lastTimesScore = module.passedQuestions;

                // Tính điểm trung bình cho passedQuestions (nếu cần)
                const averagePassedQuestions = results.length > 0
                    ? parseFloat((results.reduce((sum: any, r: { question_success: any; }) => sum + r.question_success, 0) / results.length).toFixed(2))
                    : 0;

                const evaluatePercent =
                    module.sub_activity_status === 2
                        ? 100
                        : module.sub_activity_status === 1
                            ? module.passedQuestions > 0 && module.totalQuestions > 0
                                ? Math.floor((module.passedQuestions / module.totalQuestions) * 100)
                                : 0
                            : 0;

                // Các giá trị điểm số
                const highestScore = module?.highestScore || 0;
                const lowestScore = module?.lowestScore || 0;

                return {
                    skillName: module.skillName,
                    practiceCount: module.total_times,
                    totalQuestions: module.totalQuestions,
                    passedQuestions: averagePassedQuestions,
                    evaluatePercent: evaluatePercent,
                    sub_activity_status: module.sub_activity_status,
                    lastTimesScore: lastTimesScore, // Số câu đúng lần gần nhất
                    highestScore: highestScore, // Số câu đúng cao nhất
                    lowestScore: lowestScore, // Số câu đúng thấp nhất
                    latest_times: module.latest_times ? formatLatestTimes(module.latest_times) : 'Không có dữ liệu',
                    submodule_id: practiceDashboardData?.sub_module_child_report?.find(
                        (m: SubModuleReport) => m.submodule_child_name === module.skillName
                    )?.submodule_child_id
                };
            });

            setSkillsData(processedData as ProcessedSkillData[]);
            setRefreshing(false);
        }
        // ... rest of the code
    }, [practiceDashboardData]);

    // Add effect to update height
    useEffect(() => {
        const updateHeight = () => {
            if (skillsTableRef.current) {
                const height = skillsTableRef.current.getBoundingClientRect().height;
                setTableHeight(height);
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);

        return () => window.removeEventListener('resize', updateHeight);
    }, [skillsData]); // Update when data changes

    useEffect(() => {
        setEncouragementMessage(getEncouragementMessage());
    }, [skillsData]);

    useEffect(() => {
        resetPracticeEnrollDataAction();
    }, []);

    // Xử lý dữ liệu chi tiết khi có response từ API
    useEffect(() => {
        if (studentReportingDetail && studentReportingDetail.data) {
            const details = studentReportingDetail.data.map((item: any, index: number) => {
                // Tính toán các giá trị từ dữ liệu API
                const scoreRatio = item.total_questions > 0
                    ? Math.round((item.pass_questions / item.total_questions) * 100)
                    : 0;

                // Giả sử passed nếu tỉ lệ đúng >= 50%
                const passed = scoreRatio >= 50;

                // Tính thời gian từ created_date và updated_date
                const startTime = item.created_date;
                const endTime = item.updated_date;
                const durationMinutes = startTime && endTime
                    ? dayjs(endTime).diff(dayjs(startTime), 'minute')
                    : 0;

                return {
                    ...item,
                    attempt_number: index + 1,
                    score_ratio: scoreRatio,
                    passed: passed,
                    start_time: startTime,
                    end_time: endTime,
                    duration_minutes: durationMinutes,
                    score: `${item.pass_questions}/${item.total_questions}`,
                };
            });

            setAttemptDetails(details);
            setDetailLoading(false);
        }
    }, [studentReportingDetail]);

    const handleCheckDevice = (subModuleId: string, classId: string) => {
        let edx_course_id = '';
        if (filterData?.id) {
            const module_current = studentClassModuleList.find((module: { id: number; }) => module.id.toString() === filterData?.id.toString());
            if (module_current) {
                edx_course_id = module_current?.edx_course_id;
            }
            setCurrentModulePracticeAction(filterData?.id);

        } else {
            setCurrentModulePracticeAction('');
        }
        if (edx_course_id) {
            practiceEnrollSingleItemAction({
                enrollments: [
                    {
                        username: auth?.username,
                        course_id: edx_course_id,
                        status: 'active',
                        is_check: true
                    }
                ]
            })
        }
        history.push(`/student/practice/topic?id=${subModuleId}&class=${classId}`)
    }

    const handleViewDetail = async (skill: ProcessedSkillData) => {
        setSelectedSkill(skill);
        setDetailLoading(true);
        setShowDetailModal(true);

        try {
            // Lấy student_id từ userDetail và submodule_id từ skill
            const student_id = userDetail?.id?.toString() || '';
            const submodule_id = skill.submodule_id?.toString() || '';

            if (submodule_id && student_id) {
                await fetchStudentReportingDetailAction({
                    submodule_id,
                });
            } else {
                console.error("Missing submodule_id or student_id");
                setAttemptDetails([]);
                setDetailLoading(false);
            }
        } catch (error) {
            console.error("Error fetching report detail:", error);
            setAttemptDetails([]);
            setDetailLoading(false);
        }
    };

    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        setSelectedSkill(null);
        setAttemptDetails([]);
        setSelectedAttempt(null);
    };

    const handleRefreshData = () => {
        setRefreshing(true);
        if (filterData?.id) {
            fetchReportStudentPracticeActivityAction({
                module_id: filterData?.id,
                start_date: '01/01/1966',
                end_date: '01/01/2100',
                status: 2
            });
        }
        setRefreshing(false);
    };

    const formatDuration = (record: AttemptDetail) => {
        if (!record.start_time || !record.end_time) return "0s";

        const start = dayjs(record.start_time);
        const end = dayjs(record.end_time);

        const totalSeconds = end.diff(start, 'second');

        if (totalSeconds < 60) {
            return `${totalSeconds}s`;
        }

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        let result = "";

        if (hours > 0) {
            result += `${hours}h`;
            if (minutes > 0) {
                result += ` ${minutes}p`;
            }
        } else {
            result += `${minutes}p`;
        }

        if (seconds > 0) {
            result += ` ${seconds}s`;
        }

        return result;
    };

    const detailColumns: ColumnsType<AttemptDetail> = [
        {
            title: 'Lượt làm',
            dataIndex: 'attempt_number',
            key: 'attempt_number',
            align: 'center',
            width: 80,
            render: (value) => (
                <div className="flex flex-col items-center">
                    <span className="font-bold">Lượt {value}</span>
                </div>
            )
        },
        {
            title: 'Bắt đầu',
            dataIndex: 'created_date',
            key: 'created_date',
            align: 'center',
            width: 140,
            render: (value) => (
                <div className="flex flex-col items-center">
                    <span>{dayjs(value).format('DD/MM/YYYY')}</span>
                    <span className="text-xs text-gray-500">
                        {dayjs(value).format('HH:mm:ss')}
                    </span>
                </div>
            )
        },
        {
            title: 'Kết thúc',
            dataIndex: 'updated_date',
            key: 'updated_date',
            align: 'center',
            width: 140,
            render: (value) => (
                <div className="flex flex-col items-center">
                    <span>{dayjs(value).format('DD/MM/YYYY')}</span>
                    <span className="text-xs text-gray-500">
                        {dayjs(value).format('HH:mm:ss')}
                    </span>
                </div>
            )
        },
        {
            title: 'Thời gian làm',
            dataIndex: 'duration_minutes',
            key: 'duration_minutes',
            align: 'center',
            width: 120,
            render: (_, record) => (
                <div className="flex items-center justify-center gap-1">
                    <Clock size={14} className="text-blue-500" />
                    <span className="font-medium">{formatDuration(record)}</span>
                </div>
            )
        },
        {
            title: 'Điểm số',
            key: 'score',
            align: 'center',
            width: 150,
            render: (_, record) => {
                const scoreText = `${record.pass_questions}/${record.total_questions}`;
                const percentage = record.score_ratio || 0;

                return (
                    <div className={`flex flex-col items-center ${record.passed ? 'text-green-600' : 'text-red-600'}`}>
                        <span className="font-bold text-lg mt-1">{scoreText}</span>
                    </div>
                );
            }
        },
        {
            title: 'Chi tiết',
            key: 'attempt_detail',
            align: 'center',
            width: 90,
            render: (_, record) => (
                <button
                    type="button"
                    className="mx-auto flex cursor-pointer text-blue-600 hover:text-blue-800"
                    title="Xem kết quả từng câu"
                    onClick={() => setSelectedAttempt(record)}
                >
                    <Eye size={16} />
                </button>
            ),
        },
        // {
        //     title: 'Bài tập',
        //     dataIndex: 'submodule_name',
        //     key: 'submodule_name',
        //     width: 250,
        //     render: (value) => (
        //         <div className="flex items-start gap-2">
        //             <BookOpen size={14} className="mt-1 text-gray-500 flex-shrink-0" />
        //             <span className="text-sm line-clamp-2">{value}</span>
        //         </div>
        //     )
        // },
    ];

    const renderDetailModalContent = () => {
        if (!selectedSkill) return null;

        const summary = {
            total_attempts: attemptDetails.length,
            passed_attempts: attemptDetails.filter(a => a.passed).length,
            failed_attempts: attemptDetails.filter(a => !a.passed).length,
            total_questions_attempted: attemptDetails.reduce((sum, a) => sum + a.total_questions, 0),
            total_correct_answers: attemptDetails.reduce((sum, a) => sum + a.pass_questions, 0),
        };

        const averageScore = summary.total_questions_attempted > 0
            ? Math.round((summary.total_correct_answers / summary.total_questions_attempted) * 100)
            : 0;

        return (
            <div className="flex flex-col h-full">
                {/* Header - Fixed - Không scroll */}
                <div className="flex-shrink-0">
                    <div className="flex justify-between items-center mb-4 pb-4 border-b">
                        <div>
                            <h2 className="text-xl font-bold">Chi tiết lần làm bài</h2>
                            <div className="mt-2 space-y-1 text-sm">
                                <div className="flex items-center gap-2">
                                    <span className="font-semibold">Học sinh:</span>
                                    <Tag color="blue">
                                        {userDetail?.first_name || ''} {userDetail?.last_name || ''}
                                    </Tag>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className="font-semibold">Bài tập:</span>
                                    <span className="text-gray-700">{selectedSkill.skillName}</span>
                                </div>
                            </div>
                        </div>
                        <button
                            onClick={handleCloseDetailModal}
                            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                            aria-label="Đóng"
                        >
                            <X size={20} />
                        </button>
                    </div>
                </div>

                {/* Content - Scroll từ đây trở xuống */}
                <div className="flex-1 overflow-y-auto pr-1">
                    {detailLoading ? (
                        <div className="flex justify-center py-10">
                            <Spin size="large" />
                        </div>
                    ) : attemptDetails.length > 0 ? (
                        <>
                            {/* Thống kê */}
                            {/* <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border">
                                <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-sm">
                                    <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                                        <div className="font-semibold text-gray-600">Tổng lượt làm</div>
                                        <div className="text-2xl font-bold text-blue-600 mt-1">{summary.total_attempts}</div>
                                    </div>
                                    <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                                        <div className="font-semibold text-gray-600">Lượt đạt</div>
                                        <div className="text-2xl font-bold text-green-600 mt-1">{summary.passed_attempts}</div>
                                    </div>
                                    <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                                        <div className="font-semibold text-gray-600">Lượt không đạt</div>
                                        <div className="text-2xl font-bold text-red-600 mt-1">{summary.failed_attempts}</div>
                                    </div>
                                    <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                                        <div className="font-semibold text-gray-600">Tổng câu đã làm</div>
                                        <div className="text-2xl font-bold text-purple-600 mt-1">{summary.total_questions_attempted}</div>
                                    </div>
                                    <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                                        <div className="font-semibold text-gray-600">Tỉ lệ đúng TB</div>
                                        <div className="text-2xl font-bold text-orange-600 mt-1">{averageScore}%</div>
                                    </div>
                                </div>
                            </div> */}

                            {/* Bảng chi tiết */}
                            <div className="bg-white rounded-lg border overflow-hidden">
                                <div className="overflow-x-auto">
                                    <Table
                                        dataSource={attemptDetails}
                                        columns={detailColumns}
                                        rowKey="id"
                                        pagination={false}
                                        size="middle"
                                        bordered
                                        className="custom-ant-table min-w-full"
                                        scroll={{ y: 350 }}
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-10">
                            <div className="text-gray-400 mb-4">
                                <Eye size={48} className="mx-auto" />
                            </div>
                            <p className="text-gray-500 mb-2">Không có dữ liệu lượt làm bài</p>
                            <p className="text-gray-400 text-sm">
                                Bạn chưa thực hiện bài tập này hoặc không có dữ liệu
                            </p>
                        </div>
                    )}
                </div>
                <div className="flex items-center gap-3 p-4 bg-gradient-to-r from-blue-50 to-white rounded-xl shadow-sm">
                    <div className="p-2 bg-blue-100 rounded-lg">
                        <span className="text-xl">📊</span>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Tổng số lần đã làm</div>
                        <div className="text-2xl font-bold text-blue-700">{summary.total_attempts}</div>
                    </div>
                </div>
            </div>
        );
    };

    //tableeeeeee
    const skillColumns: ColumnsType<ProcessedSkillData> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            align: 'center',
            width: 70,
            render: (_, __, index) => index + 1,
        },
        {
            title: 'Bài tập',
            dataIndex: 'skillName',
            key: 'skillName',
            width: '27%',
            ellipsis: true,
            render: (text: string) => (
                <span className="font-medium long-title" title={text}>{text}</span>
            )
        },
        {
            title: 'Số lần làm bài',
            dataIndex: 'practiceCount',
            key: 'practiceCount',
            width: '18%',
            align: 'center',
            render: (value: number) => <span>{value}</span>
        },
        {
            title: 'Lần luyện gần nhất',
            dataIndex: 'latest_times',
            key: 'latest_times',
            width: '22%',
            align: 'center',
            render: (value: string) => <span>{value}</span>
        },
        {
            title: 'Điểm gần nhất',
            key: 'lastTimesScore',
            width: '20%',
            align: 'center',
            render: (_, record) => {
                return (
                    <div className="flex flex-col items-center">
                        <span className="font-bold text-green-600">
                            {record.lastTimesScore}/{record.totalQuestions}
                        </span>
                    </div>
                );
            }
        },
                {
            title: 'Điểm cao nhất',
            key: 'highestScore',
            width: '20%',
            align: 'center',
            render: (_, record) => {
                return (
                    <div className="flex flex-col items-center">
                        <span className="font-bold text-blue-600">
                            {record.highestScore}/{record.totalQuestions}
                        </span>
                    </div>
                );
            }
        },
        {
            title: 'Điểm thấp nhất',
            key: 'lowestScore',
            width: '20%',
            align: 'center',
            render: (_, record) => {
                return (
                    <div className="flex flex-col items-center">
                        <span className="font-bold text-red-600">
                            {record.lowestScore}/{record.totalQuestions}
                        </span>
                    </div>
                );
            }
        },
        
        {
            title: 'Thao tác',
            key: 'action',
            width: '15%',
            align: 'center',
            render: (_, record) => (
                <div className="flex justify-center">
                    <button
                        onClick={() => handleViewDetail(record)}
                        className="flex items-center justify-center gap-1 text-blue-600 transition-colors text-sm"
                        title="Xem chi tiết lượt làm"
                    >
                        <Eye size={14} />
                    </button>
                </div>
            )
        },
    ];

    return (
        <div className='flex flex-col gap-3 activity-wrapper lg:pr-6 md:pr-6 sm:pr-2'>
            <div className="mb-2">
                <div className="flex items-center gap-3 mb-1">
                    <div className="w-3 h-8 rounded-full"></div>
                    <h1 className='text-[20px] font-[600] text-gray-800 tracking-tight'>
                        Báo cáo kết quả làm bài tập
                    </h1>
                </div>
                <p className="text-gray-500 text-sm ml-6">
                    Theo dõi và đánh giá quá trình học tập của bạn
                </p>
            </div>
            <div className=" mx-4 p-4 bg-white rounded-lg shadow-sm border">
                <div className="flex flex-wrap items-center gap-4">
                    <div className="flex flex-col">
                        {/* <label className="text-sm font-medium text-gray-600 mb-2">Môn học</label> */}
                        <Select
                            className="w-64"
                            placeholder="Chọn môn học"
                            options={moduleOptions}
                            value={filterData?.id}
                            disabled={!moduleOptions?.length}
                            onChange={handleChangeModule}
                        />
                    </div>
                    <div className="ml-auto flex items-center gap-2">
                        <Button
                            onClick={handleRefreshData}
                            loading={refreshing}
                            className="flex items-center gap-2"
                            type="default"
                            icon={<RefreshCw size={16} className={refreshing ? "animate-spin" : ""} />}
                        >
                            Làm mới
                        </Button>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-6">
                <div className="w-full px-4">
                    <div className="overflow-x-auto">
                        <div className="flex gap-4 items-center">
                            <div
                                ref={skillsTableRef}
                                className=" rounded-lg flex flex-col overflow-hidden flex-1"
                            >
                                <Table
                                    dataSource={practicedSkills}
                                    columns={skillColumns}
                                    rowKey={(record) => record.skillName}
                                    className="min-w-full"
                                    bordered
                                    pagination={false}
                                    loading={loading || refreshing}
                                    scroll={{ y: 350 }}
                                    locale={{
                                        emptyText: (
                                            <div className="p-4 text-center text-gray-500">
                                                Chưa có bài luyện tập nào được ghi nhận
                                            </div>
                                        )
                                    }}
                                    components={{
                                        header: {
                                            cell: (props: any) => (
                                                <th
                                                    {...props}
                                                    className="bg-[#008BB7] text-white p-3 text-center"
                                                    style={{
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1,
                                                        background: '#008BB7'
                                                    }}
                                                />
                                            )
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PracticeAttemptDetail
                open={Boolean(selectedAttempt)}
                activityId={selectedAttempt?.id}
                attemptNumber={selectedAttempt?.attempt_number}
                onClose={() => setSelectedAttempt(null)}
            />

            {/* Modal chi tiết */}
            <Modal
                isOpen={showDetailModal}
                className="p-4"
                innerClassName="w-full max-w-5xl h-[80vh] flex flex-col"
            >
                {renderDetailModalContent()}
            </Modal>
        </div>
    );
};

// Add these styles to your CSS
const styles = `
@keyframes bounce {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
}

.animate-bounce {
    animation: bounce 1s infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.animate-spin {
    animation: spin 1s linear infinite;
}

/* Custom styles for Ant Design Table */
.custom-ant-table .ant-table-thead > tr > th {
    color: white !important;
    font-weight: 600;
}

.custom-ant-table .ant-table-tbody > tr > td {
    border-bottom: 1px solid #e8e8e8;
}

.custom-ant-table .ant-table-tbody > tr:hover > td {
    background-color: #f5f5f5;
}

.custom-ant-table .ant-table {
    border: none;
    border-radius: 0;
}

.custom-ant-table .ant-table-container {
    border: none;
}

.custom-ant-table .ant-table-thead {
    position: sticky;
    top: 0;
    z-index: 1;
}
`;

// Add the styles to the document
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default ReportChart;